import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { COMPANY } from "../../data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative pt-32 lg:pt-40 pb-0 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-end">
          {/* Left: headline */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="h-[2px] w-10 bg-[#F5B800]" />
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1C9FD8]">
                Consultation · Design · Development · Training
              </p>
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter leading-[1.05] text-slate-900">
              Embedded systems,
              <br />
              engineered with <span className="text-[#1E4D8B]">depth</span>
              <span className="text-[#F5B800]">.</span>
            </h1>
            <p className="mt-8 text-base lg:text-lg text-slate-600 leading-relaxed max-w-xl">
              {COMPANY.intro}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 pb-16 lg:pb-24">
              <button
                data-testid="hero-primary-cta"
                onClick={() => scrollTo("training")}
                className="group inline-flex items-center justify-center gap-2 bg-[#1E4D8B] text-white hover:bg-[#153a6b] font-medium px-8 py-4 text-sm transition-colors"
              >
                Explore Training
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                data-testid="hero-secondary-cta"
                onClick={() => scrollTo("contact")}
                className="inline-flex items-center justify-center gap-2 bg-transparent border border-slate-300 text-slate-900 hover:border-[#1E4D8B] hover:text-[#1E4D8B] font-medium px-8 py-4 text-sm transition-colors"
              >
                Get in Touch
              </button>
            </div>
          </motion.div>

          {/* Right: engineering image */}
          <motion.div
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative border-l-2 border-t-2 border-[#F5B800]">
              <img
                src="https://images.unsplash.com/photo-1562408590-e32931084e23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Blue microchip circuit board"
                className="w-full h-[340px] lg:h-[460px] object-cover"
              />
              <div className="absolute bottom-0 left-0 bg-[#1E4D8B] text-white px-5 py-3 font-display font-bold text-sm tracking-tight">
                ARM · IoT · Linux · RTOS
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="border-b border-slate-200" />
    </section>
  );
};
